<div class="container sms009">
  <!-- ヘッダーエリア -->
  <app-header></app-header>

  <!-- メインエリア -->
  <div class="main-area">

    <!-- コンテンツエリア -->
    <div class="content-area" [style.width]="windowsWidth">

      <!-- フォームエリア -->
      <form class="sms-form">
        <div [formGroup]="smsForm">

          <br>
          <!-- 文言 -->
          <div>
            <mat-label class="message">{{lblName}}</mat-label>
          </div>
          <br>
          <!-- 文言 -->
          <div>
            <mat-label class="message">{{lblMessage01}}</mat-label>
          </div>
          <br>

          <!-- 氏名（漢字） -->
          <div>
            <mat-form-field appearance="standard" class="input-name-field">
              <mat-label>{{lblNameSei}}</mat-label>
              <input matInput formControlName="txtNameSei" class="input-name-text" tabindex="1" maxlength="10" />
              <mat-error *ngIf="smsForm.get('txtNameSei')?.invalid">*</mat-error>
            </mat-form-field>
            <mat-form-field appearance="standard" class="input-name-field">
              <mat-label>{{lblNameMei}}</mat-label>
              <input matInput formControlName="txtNameMei" class="input-name-text"  tabindex="2" maxlength="10" />
              <mat-error *ngIf="smsForm.get('txtNameMei')?.invalid">*</mat-error>
            </mat-form-field>
          </div>

          <!-- 氏名（カナ） -->
          <div>
            <mat-form-field appearance="standard" class="input-name-field">
              <mat-label>{{lblKanaSei}}</mat-label>
              <input matInput formControlName="txtKanaSei" class="input-name-text"  tabindex="3" maxlength="20" />
              <mat-error *ngIf="smsForm.get('txtKanaSei')?.invalid">*</mat-error>
            </mat-form-field>
            <mat-form-field appearance="standard" class="input-name-field">
              <mat-label>{{lblKanaMei}}</mat-label>
              <input matInput formControlName="txtKanaMei" class="input-name-text"  tabindex="4" maxlength="20" />
              <mat-error *ngIf="smsForm.get('txtKanaMei')?.invalid">*</mat-error>
            </mat-form-field>
          </div>
          <br>

          <!-- 生年月日 -->
          <div>
            <mat-label class="message">{{lblBirthDay}}</mat-label>
          </div>
          <br><br>

          <!-- 文言 -->
          <div>
            <mat-label class="message">{{lblMessage02}}</mat-label>
            <br>
            <mat-label class="message">{{lblMessage03}}</mat-label>
            <br>
            <mat-label class="message">{{lblMessage04}}</mat-label>
            <br>
            <br>
            <mat-label class="message">{{lblMessage05}}：<a href="{{lblTel01}}">{{lblTel02}}</a></mat-label>
          </div>

          <br><br><br>
          <!-- ボタン -->
          <div class="button-area">
            <button type="submit" mat-raised-button [disabled]="!isEnableBtnSend" (click)="executeClick()" tabindex="5">{{lblBtnSend}}</button>
          </div>

        </div>
      </form>

    </div>
  </div>

  <!-- フッターエリア -->
  <div class="footer-area">
    <div class="img-area">
      <img class="img-logo" src="assets/images/footer_ofi_copyright.png" />
    </div>
    <div class="data-operation-button-area">
      <button type="button" mat-raised-button [disabled]="!isEnableBtnMenu" (click)="backClick()" accesskey="q" tabindex="6">{{lblBtnMenu}}</button>
    </div>
  </div>

</div>
